import React, {useState} from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { useParams, useSearchParams } from "react-router-dom";
import MyFrame from "./MyFrame";
import "./RightColomn.css";
import PageNotFound from "../pages/PageNotFound";
import AlertPopup from "./Alert";
import MenuContext from "../store/menu-context";


const RightColomn = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [htmlFileString, setHtmlFileString] = useState({});
  // const htmlFileString ={};
  
  // let htmlFileString = useContext(MenuContext);
  // let htmlFileString = {};

  // sessionStorage.setItem('menuStructure', JSON.stringify(htmlFileString));

  if(Object.keys(htmlFileString).length === 0){
    try{
      var tempHtmlFileString = JSON.parse(sessionStorage.getItem('menuStructure'));
      // console.log(`tempHtmlFileString: ${tempHtmlFileString}`);
      // console.log(`tempHtmlFileString: ${JSON.stringify(tempHtmlFileString)}`);
      if(tempHtmlFileString === null || tempHtmlFileString === ""){
        fetch(`/staticData/NavigationConfig.json`)
          .then((res) => res.json())
          .then((data) => {
              // console.log(`MenuContextProvider.useEffect data is: ${data}`);
              setHtmlFileString(data);
              // sessionStorage.setItem('menuStructure', JSON.stringify(data));
          });
      }else{
        setHtmlFileString(tempHtmlFileString)
      }
    }catch(e){
      fetch(`/staticData/NavigationConfig.json`)
        .then((res) => res.json())
        .then((data) => {
            // console.log(`RightColomn.js data is: ${data}`);
            // htmlFileString = data;
            // setHtmlFileString(sessionStorage.getItem('menuStructure'))
            setHtmlFileString(data)
            // setMenuItems(data);
            // sessionStorage.setItem('menuStructure', JSON.stringify(data));
        });
    }
  }
  // console.log("htmlFileString before use Context: ", htmlFileString);
  // const htmlFileString = useContext(MenuContext);
  // console.log("htmlFileString after use Context: ", htmlFileString);
  
  const params = useParams();

  // useEffect(() => {
  //   if(Object.keys(htmlFileString).length === 0){
  //     console.log('htmlFileString is empty');
      
  //     try{
  //       // htmlFileString = JSON.parse(sessionStorage.getItem('menuStructure'));
  //       setHtmlFileString(JSON.parse(sessionStorage.getItem('menuStructure')))
  //     }catch(e){
  //       fetch(`/staticData/NavigationConfig.json`)
  //         .then((res) => res.json())
  //         .then((data) => {
  //             console.log(`RightColomn.js data is: ${data}`);
  //             // htmlFileString = data;
  //             setHtmlFileString(data);
  //             // setMenuItems(data);
  //             // sessionStorage.setItem('menuStructure', JSON.stringify(data));
  //         });
  //     }
  //   }

  // },[params])

  

  const generateContent = () => {
    // console.log(`This is params: ${JSON.stringify(params)}`);
    // console.log(`This is params.externalContent: ${params.externalContent}`);
    const event_id = searchParams.get("event_id");
    // console.log(event_id);
    // console.log(`This is props: ${JSON.stringify(props)}`);
    if(event_id){
      return (
        <div>
          <MyFrame
            frameContent={`https://msmta.org/registration/regMain.php?event_id=${event_id}`}
          />
        </div>
      );
    }

    if (params.externalContent) {
      // console.log(htmlFileString);
      // console.log(params.externalContent);
      // console.log(Object.keys(htmlFileString["redirect"]));
      // if(!Object.keys(htmlFileString["redirect"]).includes(params.externalContent)){
      //   console.log(`${params.externalContent} not found`);
      // }else{
      //   console.log(`${params.externalContent} found`);
      // }
      if (Object.keys(htmlFileString).length != 0) {
        if (
          !Object.keys(htmlFileString["redirect"]).includes(params.externalContent)) {
          // console.log(`${params.externalContent} not found`);
          return (
            <div>
              <PageNotFound />
            </div>
          );
        } else {
          // console.log(`${params.externalContent} found`);
          // console.log(htmlFileString["redirect"][params.externalContent]);
          return (
            <div>
              <MyFrame
                frameContent={
                  htmlFileString["redirect"][params.externalContent]
                }
              />
            </div>
          );
        }
      }else {
        return (
          <div>
            {/* Loading .... */}
          </div>
        );
      }
    } else {
      return <div>{props.children}</div>;
    }
  };

  return (
    <Container>
      <AlertPopup />
      <Row>
        {generateContent()}
      </Row>
    </Container>
  );
};

export default RightColomn;
